"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentfulModels = void 0;
// In order to properly type check valid contentful model id and to avoid typos when referring to it
// we would need an enum, but as generate-types is a third party script we are creating this object
// that works just like a enum and will be enough to trigger compilation errors.
exports.ContentfulModels = {
    abTestSection: 'abTestSection',
    abVariation: 'abVariation',
    accordionItem: 'accordionItem',
    accordionSection: 'accordionSection',
    actionLink: 'actionLink',
    analyticsEvent: 'analyticsEvent',
    antiAtomSection: 'antiAtomSection',
    atomSection: 'atomSection',
    bannerSection: 'bannerSection',
    ciitizenAppAssets: 'ciitizenAppAssets',
    collection: 'collection',
    columnsSection: 'columnsSection',
    componentBlock: 'componentBlock',
    componentCopy: 'componentCopy',
    decorativeShape: 'decorativeShape',
    emailCaptureFormSection: 'emailCaptureFormSection',
    externalLink: 'externalLink',
    footerBlock: 'footerBlock',
    footerSection: 'footerSection',
    footerSubsection: 'footerSubsection',
    footnoteSection: 'footnoteSection',
    globalTextCopy: 'globalTextCopy',
    heroImageSection: 'heroImageSection',
    heroTextBoxSection: 'heroTextBoxSection',
    heroTextSection: 'heroTextSection',
    iconGrid: 'iconGrid',
    iconGridItem: 'iconGridItem',
    image: 'image',
    internalLink: 'internalLink',
    layout: 'layout',
    layoutFooter: 'layoutFooter',
    layoutFooterColumn: 'layoutFooterColumn',
    leadspaceWithShape: 'leadspaceWithShape',
    link: 'link',
    listOfLinksBlock: 'listOfLinksBlock',
    listOfLinksItem: 'listOfLinksItem',
    listOfLinksSection: 'listOfLinksSection',
    media: 'media',
    mediaContent: 'mediaContent',
    mediaImageOrVideo: 'mediaImageOrVideo',
    mediaTextAndMediaSection: 'mediaTextAndMediaSection',
    mediaWithContent: 'mediaWithContent',
    meta: 'meta',
    navBar: 'navBar',
    navigationHeader: 'navigationHeader',
    navigationL1: 'navigationL1',
    navigationL2: 'navigationL2',
    navigationSearch: 'navigationSearch',
    navigationSection: 'navigationSection',
    navSubSection: 'navSubSection',
    notificationBanner: 'notificationBanner',
    page: 'page',
    pageCopy: 'pageCopy',
    panelCardsItem: 'panelCardsItem',
    panelCardsSection: 'panelCardsSection',
    patientTestLink: 'patientTestLink',
    pitExtendedClaimPage: 'pitExtendedClaimPage',
    postersAndPresentations: 'postersAndPresentations',
    publication: 'publication',
    redirect: 'redirect',
    requestAKit: 'requestAKit',
    requestAKitPage: 'requestAKitPage',
    sectionCardsItem: 'sectionCardsItem',
    sectionCarousel: 'sectionCarousel',
    sectionColumnsItem: 'sectionColumnsItem',
    sectionCustomerReview: 'sectionCustomerReview',
    sectionFactBanner: 'sectionFactBanner',
    sectionIconCards: 'sectionIconCards',
    sectionIconCardsItem: 'sectionIconCardsItem',
    sectionListWithIconBullets: 'sectionListWithIconBullets',
    sectionListWithIconBulletsItem: 'sectionListWithIconBulletsItem',
    sectionLogos: 'sectionLogos',
    sectionNextActionBanner: 'sectionNextActionBanner',
    sectionProductCards: 'sectionProductCards',
    sectionProductCardsItem: 'sectionProductCardsItem',
    sectionQuiz: 'sectionQuiz',
    sectionStepperHover: 'sectionStepperHover',
    sectionStepperHoverItem: 'sectionStepperHoverItem',
    sectionStepperStatic: 'sectionStepperStatic',
    sectionStepperStaticItem: 'sectionStepperStaticItem',
    sectionTechSpec: 'sectionTechSpec',
    sectionTechSpecItem: 'sectionTechSpecItem',
    statusPage: 'statusPage',
    stickyNote: 'stickyNote',
    stickyNoteComment: 'stickyNoteComment',
    tabsSection: 'tabsSection',
    tabsSectionItem: 'tabsSectionItem',
    teamsBlock: 'teamsBlock',
    teamsBlockGroup: 'teamsBlockGroup',
    teamsBlockMember: 'teamsBlockMember',
    testCatalogMainCategorySection: 'testCatalogMainCategorySection',
    textAndMediaSection: 'textAndMediaSection',
    textCopy: 'textCopy',
    tileItem: 'tileItem',
    // eslint-disable-next-line spellcheck/spell-checker
    tilesWIthIcons: 'tilesWIthIcons',
    video: 'video',
    videoPopupLink: 'videoPopupLink',
    webinar: 'webinar',
};
//# sourceMappingURL=contentfulModels.js.map